import type { IpdOrderKind, IpdTaskKind } from '@his/shared';
import { tr, translateServerMessage } from '@/lib/i18n-core';
import { splitMinutes, type OrderProblem, type PreviewEntry } from './order-form';

export function kindLabel(kind: IpdOrderKind): string {
  return tr('ipd', `io_kind_${kind}`);
}

export function taskKindLabel(kind: IpdTaskKind): string {
  return tr('ipd', `io_task_kind_${kind}`);
}

export function everyLabel(minutes: number): string {
  if (minutes >= 60 && minutes % 60 === 0) return tr('ipd', 'io_form_every_hours', { hours: minutes / 60 });
  return tr('ipd', 'io_form_every_minutes', { minutes });
}

export function durationText(minutes: number): string {
  const { hours, minutes: rest } = splitMinutes(minutes);
  if (hours === 0) return tr('ipd', 'io_form_duration_minutes', { minutes: rest });
  if (rest === 0) return tr('ipd', 'io_form_duration_hours', { hours });
  return tr('ipd', 'io_form_duration_hours_minutes', { hours, minutes: rest });
}

export function problemText(problem: OrderProblem): string {
  switch (problem.code) {
    case 'custom':
      return translateServerMessage(problem.message) ?? problem.message;
    case 'required':
      return tr('ipd', 'io_form_err_required');
    case 'too_short':
      return tr('ipd', 'io_form_err_too_short', { min: problem.limit ?? 1 });
    case 'too_long':
      return tr('ipd', 'io_form_err_too_long', { max: problem.limit ?? 0 });
    case 'too_small':
      return tr('ipd', 'io_form_err_min', { min: problem.limit ?? 0 });
    case 'above':
      return tr('ipd', 'io_form_err_above', { min: problem.limit ?? 0 });
    case 'too_big':
      return tr('ipd', 'io_form_err_max', { max: problem.limit ?? 0 });
    case 'not_integer':
      return tr('ipd', 'io_form_err_whole');
    default:
      return tr('ipd', 'io_form_err_invalid');
  }
}

export function previewEntryDetail(entry: PreviewEntry): string | null {
  if (entry.unit !== undefined && entry.step) return `${tr('ipd', 'io_form_unit_number', { number: entry.unit })} · ${tr('ipd', `io_form_step_${entry.step}`)}`;
  if (entry.bag !== undefined) return tr('ipd', 'io_form_bag_number', { number: entry.bag });
  if (entry.meal) return /^meal-\d+$/.test(entry.meal) ? tr('ipd', 'io_form_meal_other') : tr('ipd', `io_form_meal_${entry.meal}`);
  if (entry.initial) return tr('ipd', 'io_form_initial_check');
  return null;
}
